import React from "react";
import { Routes, Route } from "react-router-dom";
import ListOoraTomtomTraffic from "../Components/Oora Tomtom Traffic/listOoraTomtomTraffic";
import ViewOoraTomtomTraffic from "../Components/Oora Tomtom Traffic/viewOoraTomtomTraffic";

const OoraTomtomTrafficRoutes = () => {
  return (
    <Routes>
      <Route path="/oora_tomtom_traffic" element={<ListOoraTomtomTraffic></ListOoraTomtomTraffic>}></Route>
      <Route path="/oora_tomtom_traffic/:id" element={<ViewOoraTomtomTraffic></ViewOoraTomtomTraffic>}></Route>
    </Routes>
  );
};

export default OoraTomtomTrafficRoutes;